
const PRODUCT_IMAGE_CAROUSEL_IMAGE_CLASS = 'block-product-image--carousel';
const PRODUCT_IMAGE_SELECTOR = 'figure';
const PRODUCT_IMAGE_CAROUSEL_TARGET_SELECTOR = '[data-product-image-carousel]';

export default class ProductImageCarousel {
    constructor() {
        this.build();
    }

    getDefaultSettings() {
        return {
            loop: false,
            rewind: true,
            margin: 10,
            nav: true,
            items: 1,
            autoHeight: true
        }
    }

    getSettingsWithoutNavigation() {
        return {
            loop: false,
            rewind: true,
            margin: 10,
            nav: false,
            items: 1,
            autoHeight: true,
            dots: false,
            mouseDrag: false,
            touchDrag: false
        }
    }

    build() {
        const carouselTarget = $(PRODUCT_IMAGE_CAROUSEL_TARGET_SELECTOR);
        const srcImages = $(carouselTarget).find(PRODUCT_IMAGE_SELECTOR);
        srcImages.addClass(PRODUCT_IMAGE_CAROUSEL_IMAGE_CLASS).appendTo(carouselTarget);

        if(srcImages.length > 1) {
            carouselTarget.owlCarousel(this.getDefaultSettings());
        } else {
            carouselTarget.owlCarousel(this.getSettingsWithoutNavigation());
        }
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/accelerator/assets/scripts/src/App/Product/ProductImageCarousel.js